import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CrimeCategoriesModel, CriminalModel} from '../../Models/criminal-model';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors
} from '@angular/forms';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-criminal-grid-table',
  templateUrl: './criminal-grid-table.component.html',
  styleUrls: ['./criminal-grid-table.component.less'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CriminalGridTableComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CriminalGridTableComponent),
      multi: true
    }
  ]
})
export class CriminalGridTableComponent implements OnInit, ControlValueAccessor, OnDestroy {

  public form: UntypedFormGroup;
  @Input() reset: EventEmitter<any>;
  private reset$: Subscription;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
  ) {
  }
  ngOnDestroy(): void {
    if(this.reset$) this.reset$.unsubscribe();
  }

  public get f() {
    return this.form.controls;
  }

  onTouched: () => void = () => {
  };

  public registerOnChange(fn: any): void {
    this.form.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    disabled ? this.form.disable() : this.form.enable();
  }

  public writeValue(value: CrimeCategoriesModel | any) {
    if (value) {
      value.misdemeanors.forEach((item: CriminalModel) => {
        const misdemeanors = <UntypedFormArray>this.f.misdemeanors;
        misdemeanors.push(new UntypedFormControl(item));
      });

      value.felonies.forEach((item: CriminalModel) => {
        const felonies = <UntypedFormArray>this.f.felonies;
        felonies.push(new UntypedFormControl(item));
      });
    }
  }

  public validate(c: AbstractControl): ValidationErrors | null {
    return this.form.valid ? null : {invalidForm: {valid: false, message: 'Form is invalid'}};
  }

  public ngOnInit(): void {
    this.createForm();
    this.reset$ = this.reset.subscribe(r => {
      this.resetForm();
    })
  }

  public createForm() {

    this.form = this.formBuilder.group({
      misdemeanors: this.formBuilder.array([]),
      felonies: this.formBuilder.array([]),
    });
  }

  public resetForm() {
    this.createForm();
  }
}
